<template>
    <div
        class="ag-cell-label-container ag-action-header"
        role="presentation"
    >
        <div
            class="ag-header-cell-label"
            style="position: relative; overflow: unset; width: 45px"
        >
            <span
                class="ag-header-cell-text"
                style="position: absolute; width: 45px; left: -5px"
            >
                <DropdownComp
                    class="btn-sm"
                    :buttonType="'Custom'"
                    :icon="featureIcons.SETTINGS"
                    iconPosition="left"
                    :dropdown-items="dropdownItemsWithSelectAll"
                />
            </span>
        </div>
    </div>
</template>

<script setup lang="ts">
import { DropdownComp } from '@/components';
import { featureIcons } from '@/components/Menu/featureicons';
import { computed, ref, watch } from 'vue';
import type { IGridCompExposed } from '../Classes';
import { DropdownItemCheckbox, DropdownItemSeparator, type DropdownItemTypes } from '@/objects';
import { $tm } from '@/locize';

const props = defineProps<{
    dropdownItems: DropdownItemTypes[];

    /**
     * Show a button for select all
     */
    selectAll?: boolean;

    /**
     * The grid instance. We dont care about the type here
     */
    grid: IGridCompExposed<any>;
}>();

const selectAll = ref(props.selectAll ?? false);

/**
 * Select or deselect all rows
 */
watch(selectAll, (newValue) => {
    if (newValue) {
        props.grid.selectAllRows();
    } else {
        props.grid.deselectAllRows();
    }
});

const dropdownItemsWithSelectAll = computed(() => {
    const items = [];
    if (props.selectAll) {
        items.push(
            DropdownItemCheckbox.create({
                label: $tm('general.all'),
                modelValue: selectAll,
            }),
            DropdownItemSeparator.create(),
        );
    }

    items.push(...props.dropdownItems);

    return items;
});
</script>
